import { z } from 'zod';

export const mediaFileSchema = z.object({
  fileId: z.string(),
});

export type MediaFile = z.infer<typeof mediaFileSchema>;

export const mediaFileWebSchema = z.object({
  src: z.string(),
});

export type MediaFileWeb = z.infer<typeof mediaFileWebSchema>;
